import React from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import ChildClassroomCard from "../../shared/components/ChildClassroomCard";
import ChildEmptyState from "../../shared/components/ChildEmptyState";

export default function ChildClassroomSection({
  sections,
  sectionState,
  onToggleSection,
  onOpenClassroom,
  yearFallback,
  formatStartDate,
}) {
  return (
    <div className="space-y-4">
      {sections.map((section) => (
        <section
          key={section.id}
          className="rounded-2xl border border-white/70 bg-white/85 p-4 shadow-sm dark:border-gray-700 dark:bg-gray-900/40"
        >
          <button
            type="button"
            className="flex w-full items-center justify-between text-left text-sm font-semibold uppercase tracking-wide text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 dark:text-gray-300"
            onClick={() => onToggleSection(section.id)}
            aria-expanded={!!sectionState[section.id]}
          >
            {section.title}
            {sectionState[section.id] ? <FaChevronUp /> : <FaChevronDown />}
          </button>
          {sectionState[section.id] && (
            <div className="mt-3 grid gap-3 md:grid-cols-2">
              {section.classrooms.length > 0 ? (
                section.classrooms.map((classroom, index) => (
                  <ChildClassroomCard
                    key={`${section.id}-${classroom.id || index}`}
                    classroom={classroom}
                    tone={section.tone}
                    onOpen={onOpenClassroom}
                    yearFallback={yearFallback}
                    startDateLabel={formatStartDate(classroom)}
                  />
                ))
              ) : (
                <ChildEmptyState title={section.emptyTitle} />
              )}
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
